module.exports = __webpack_public_path__ + "media/Loops Pad.017a9fd4.wav";